import { Navigate } from 'react-router-dom';
import { useApplication } from '../context/useApplication';
import { LoadingScreen } from '@lendica/components';

export const ConsentProtector = ({ children, enableConsentCheck = true }) => {
    const { loading, consent, searchParams } = useApplication();

    // If consent check is disabled, render children directly
    if (!enableConsentCheck) {
        return children;
    }

    // Otherwise, perform normal consent checking
    return loading ? (
        <LoadingScreen />
    ) : consent === false ? (
        <Navigate
            to={`../consent${searchParams.size > 0 ? `?${searchParams.toString()}` : ''}`}
            // replace
        />
    ) : (
        children
    );
};
